import {ChangeEvent, KeyboardEvent  , useEffect, useRef, useState} from "react";

export default function EditableListName(
    {
        listName,
        onListNameChange,
        disabled,
    } : {
        listName: string,
        onListNameChange : (newName: string) => void
        disabled: boolean
    }) {

    const inputRef = useRef<HTMLInputElement>(null)
    const [listNameValue, setListNameValue] = useState(listName);

    const inputChange = (event : ChangeEvent<HTMLInputElement>) => {
        setListNameValue(event.target.value);
    };

    const handleKeyDown = (event : KeyboardEvent) => {
        if (event.key === 'Enter') {
            onListNameChange(listNameValue);
            inputRef?.current?.blur();
        }
    }

    useEffect(() => {
        const eventLogger = (event : Event) => {
            if (navigator.userAgent.search(/iphone/i) > -1) {
                if (listNameValue.trim().length < 3) {
                    setListNameValue(listName);
                } else {
                    onListNameChange(listNameValue);
                }
            }
        }

        const currentRef = inputRef.current;
        currentRef?.addEventListener('focusout', eventLogger);

        return () => {
            currentRef?.removeEventListener('focusout', eventLogger);
        };
    }, [listNameValue, listName, onListNameChange]);

    useEffect(() => {
        setListNameValue(listName);
    }, [listName]);

    return (
        <>
            <input disabled={disabled} spellCheck={"false"} id={"list-name"} ref={inputRef} type={"text"} value={listNameValue} onKeyDown={handleKeyDown} onChange={inputChange} />
        </>
    );
}
